import { get } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { useSalesChannelGeneralLinkSet } from 'src/components/LinkModule/hooks';

import LinkLibrary from '@/src/constrains/LinkLibrary';
import { Field } from 'src/components/RcForm';
import { sectionProps } from 'src/tools/constant';
import styles from './css.module.less';
const FieldLinkLibrary = (props) => {
  const _params: any = useParams();

  const { contentUuid } = _params;

  const linkSet = useSalesChannelGeneralLinkSet({ contentUuid });
  const { disabled, title, name, validators, breakpoint } = props;
  const { link: lV } = validators || {};

  return (
    <Section {...sectionProps}>
      <ItemWrapper title={title}>
        <Field
          name={name}
          rules={[
            {
              validator: async (rules: any, value: any) => {
                if (lV) {
                  const res = lV(value, { breakpoint });
                  const hasError = get(res, 'hasError');
                  const errors = get(res, 'errors');
                  if (hasError) {
                    return Promise.reject(new Error((errors || []).join(',')));
                    //</ItemWrapper>throw Error((errors || []).join(','));
                  }
                }
              },
            },
          ]}>
          {(props, meta) => {
            const value = props.value;
            const onChange = props.onChange;
            const errors = get(meta, 'errors');
            return (
              <LinkLibrary
                error={(errors || []).join(' ')}
                data={value}
                onChange={onChange}
                linkSet={linkSet}
                disabled={disabled}
                hideTitle
                cannotAddToCart
                containerClassName={styles.iframeLinkWrap}
                unableDelete
              />
            );
          }}
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default FieldLinkLibrary;
